import React from 'react';
import { Content } from '../../../../../CommonComponents/OPL/StickyFooter/StickyFooter';
import { StepCard } from '../StepCard/StepCard';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { ScrollHereOnce } from '../../../../../CommonComponents/ScrollHereOnce';
import { StepFooter } from '../StepFooter/StepFooter';

interface Props {
  children: React.ReactNode;
}

export const StepContainer = ({ children }: Props) => {
  return (
    <>
      <ScrollHereOnce options={false} />

      <Box minWidth={500} mt={96}>
        <Content>
          <StepCard>
            <Text color="neutral.700" fontSize="h3" fontWeight={500}>
              Personal Info
            </Text>

            <Text as="p" color="neutral.500" mt="4">
              Please include information about your household.
            </Text>

            <Box mt="32">{children}</Box>
          </StepCard>
        </Content>

        <StepFooter />
      </Box>
    </>
  );
};
